// import axios from 'axios';

// const instance = axios.create({
//     baseURL: process.env.REACT_APP_BACKEND_URL,
//     //baseURL: "http://localhost:8080/admin",
//     //baseURL: "http://localhost:3008/api",
//     contentType: 'application/json; charset=utf-8'
// })
// console.log('Backend URL2:', process.env.REACT_APP_BACKEND_URL);

import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL, // Read from the .env file
    contentType: 'application/json; charset=utf-8'
});
console.log('Backend URL2:', process.env.REACT_APP_BACKEND_URL);

// REQUEST INTERCEPTOR
instance.interceptors.request.use(
    (config) => {

        const token = localStorage.getItem("access_token");

        if (token) {
            config.headers["access_token"] = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// RESPONSE INTERCEPTOR
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {

        if (error.response && error.response.status === 401) {

            // remove token
            localStorage.clear();

            // redirect login page
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);


const Login = async (data) => {
    try {
        const response = await instance.post('/login', data);
        return response.data;

    } catch (error) {
        console.log(error);
        return error.response.data;
    }
};
const Logout = async (data, headers) => {
    try {
        const response = await instance.patch('/logout', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token // Correctly access the token from headers
            },
        });
        return response.data;

    } catch (error) {
        console.log(error);
        return error.response.data;
    }
};
const AddUserPreview = async (data) => {
    try {
        let response = await instance.post('/addstaffpreview', data);
        return response.data;
    } catch (err) {
        console.error("Error:", err.response?.data || err.message);
        throw err;
    }
};
const AddUser = async (data, headers) => {
    try {
        let response = await instance.post('/adduser', data, {
            headers: {
                "Content-Type": "multipart/form-data",
                "access_token": headers.access_token // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.error("Error:", err.response?.data || err.message);
        throw err;
    }
};

const UpdateUser = async (data, headers) => {
    try {
        let response = await instance.patch('/userdetails', data, {
            headers: {
                "Content-Type": "multipart/form-data",
                "access_token": headers.access_token // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.error("Error:", err.response?.data || err.message);
        throw err;
    }
};


const AllUser = async (data, headers) => {
    try {
        let response = await instance.post('/alluser', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const AddQuestion = async (data, headers) => {
    try {
        let response = await instance.post('/addquestion', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err)
    }
};

const AllQuestion = async (data) => {
    try {
        let response = await instance.post('/allquestion', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const AllQuestionByExam = async (data, headers) => {
    try {
        let response = await instance.post('/allquestionbyexam', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const QuestionById = async (data, headers) => {
    try {
        // Assuming data contains the query parameters
        let response = await instance.post('/questionedit', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const UpdateQuestion = async (data, headers) => {
    try {
        let response = await instance.patch('/questionedit', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const SoftDeleteQuestion = async (data, headers) => {
    try {
        let response = await instance.patch('/question', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const AddSummary = async (data, headers) => {
    try {
        let response = await instance.post('/examsummary', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const GetQuizSummary = async (data) => {
    try {
        let response = await instance.post('/allexamsummarybyuser', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const GetQuizSummaryById = async (data, headers) => {
    try {
        let response = await instance.post('/examsummaryid', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const GetQuizSummaryByUserExam = async (data, headers) => {
    try {
        let response = await instance.post('/allexamsummarybyuserexam', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const GetQuizSummaryByUser = async (data, headers) => {
    try {
        let response = await instance.post('/allexamsummarybyuser', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const GetAllRoles = async (headers) => {
    try {
        let response = await instance.post('/allroles', null, {
            headers: {
                // "Content-Type": "application/json", // Optional: include if needed by your API
                "access_token": headers.access_token, // Pass the token in headers
            },
        });
        // console.log("roles response", response.data)
        return response.data;
    } catch (err) {
        console.log(err);
    }
};

//below should be correct after all confirmation for all roles
const AllRoles = async (data) => {
    try {
        let response = await instance.post('/allroles', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};

const GetRoleById = async (data, headers) => {
    try {
        let response = await instance.post('/role', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
        return err.response.data
    }
};
const SideMenubarPage = async (data, headers) => {
    try {
        let response = await instance.post('/sidemenubar', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
        return err.response.data
    }
};

const GetUserById = async (data, headers) => {
    try {
        let response = await instance.post('/user', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const SoftDeleteUser = async (data, headers) => {
    try {
        let response = await instance.patch('/user', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const DashBoard = async (data, headers) => {
    try {
        let response = await instance.post('/dashboard', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const Report = async (data, headers) => {
    try {
        let response = await instance.post('/report', data, {
            headers: {
                "Content-Type": "application/json", // JSON content type
                "access_token": headers.access_token, // Correctly access the token from headers
            },
        });
        return response.data;
    } catch (err) {
        console.log(err);
    }
};

const CheckInAttendance = async (data) => {
    try {
        let response = await instance.post('/entryattendance', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const CheckOutAttendance = async (data) => {
    try {
        let response = await instance.patch('/checkout', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const GetAttendanceByEntryDate = async (data) => {
    try {
        let response = await instance.post('/getattendance', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const GetAttendance = async (data) => {
    try {
        let response = await instance.post('/getattendance', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const AllSites = async (data) => {
    try {
        let response = await instance.post('/getsites', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const AddSite = async (data) => {
    try {
        let response = await instance.post('/site', data);
        return response.data;
    } catch (err) {
        console.log(err);
    }
};
const SiteProfile = async (data) => {
    try {
        let response = await instance.post('/siteprofile', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const SiteEditPage = async (data) => {
    try {
        let response = await instance.post('/siteeditpage', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const UpdateSite = async (data) => {
    try {
        let response = await instance.patch('/site', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const SoftDeleteSite = async (data) => {
    try {
        let response = await instance.patch('/deletesite', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const AttendanceAssign = async (data) => {
    try {
        let response = await instance.post('/attendanceassign', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }

};
const AttendancePageByUser = async (data) => {
    try {
        let response = await instance.post('/attendancepagebyuser', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }

};
const AttendanceEditPage = async (data) => {
    try {
        let response = await instance.post('/attendanceedit', data);
        return response.data;
    } catch (err) {
        console.log(err)
        return err.response.data

    }

};
const UpdateAttendance = async (data) => {
    try {
        let response = await instance.patch('/attendance', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }

};
const SoftDeleteAttendance = async (data) => {
    try {
        let response = await instance.post('/attendancedelete', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }

};
const HardDeleteAttendance = async (data) => {
    try {
        let response = await instance.delete('/attendancedelete', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }

};
const TimeSheet = async (data) => {
    try {
        let response = await instance.post('/timesheet', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }

};
const AddKET = async (data) => {
    try {
        let response = await instance.post('/ket', data, {
            headers: {
                "Content-Type": "multipart/form-data",
                //"access_token": headers.access_token // Correctly access the token from headers
            }
        }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const KETAddPage = async (data) => {
    try {
        let response = await instance.post('/ketaddpage', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const KETEditPage = async (data) => {
    try {
        let response = await instance.post('/keteditpage', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const KETUpdate = async (data) => {
    try {
        let response = await instance.patch('/ket', data, {
            headers: {
                "Content-Type": "multipart/form-data",
                //"access_token": headers.access_token // Correctly access the token from headers
            }
        }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const QuizEdit = async (data) => {
    try {
        let response = await instance.post('/examedit', data);
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const QuizUpdate = async (data) => {
    try {
        let response = await instance.patch('/editexamsummary', data);
        return response.data;
    } catch (err) {
        console.log(err);
        return err.response.data;
    }
}
const AllExam = async (data, headers) => {
    try {
        const response = await instance.post('/allexam', data, {
            headers: {
                "Content-Type": "application/json",
                "access_token": headers.access_token,
            }
        });
        return response.data;
    } catch (err) {
        console.log(err)
    }
};
const ExamAdd = async (data, headers) => {
    try {
        const response = await instance.post('/exam', data, {
            headers: {
                "Content-Type": "multipart/form-data",
                "access_token": headers.access_token,
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        return err.response.data
    }
};
const ConsolidatedReportPage = async (data, headers) => {
    try {
        const response = await instance.post('/consolidatedreportpage', data
            , {
                headers: {
                    "Content-Type": "application/json",
                    "access_token": headers.access_token,
                }
            }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const LeaveCategoriesGet = async (data, headers) => {
    try {
        const response = await instance.post('/getleavecategories', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const LeaveApplicationListPage = async (data, headers) => {
    try {
        const response = await instance.post('/leaveapplicationlistpage', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const LeaveAdd = async (data, headers) => {
    try {
        const response = await instance.post('/leave', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const LeaveGet = async (data, headers) => {
    try {
        const response = await instance.post('/getleave', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const LeaveApproveOrCancel = async (data, headers) => {
    try {
        const response = await instance.patch('/approveOrCancelLeave', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        return err.response.data
    }
};
const LeaveAllotmentAdd = async (data, headers) => {
    try {
        const response = await instance.post('/leaveallotment', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const LeaveAllotmentUpdate = async (data, headers) => {
    try {
        const response = await instance.patch('/leaveallotment', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
};

const Pwm = async (data, headers) => {
    try {
        const response = await instance.post('/pwm', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log(err)
    }
}
const PayslipAdd = async (data, headers) => {
    try {
        const response = await instance.post('/payslip', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        console.log("response.data", response.data)
        return response.data;
    } catch (err) {

        console.log(err);
        return err.response.data
    }
}
const PayslipGet = async (data, headers) => {
    try {
        const response = await instance.post('/payslipget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        console.log("response.data", response.data)
        return response.data;
    } catch (err) {

        console.log(err);
        return err.response.data
    }
}
const SalariedStaff = async (data, headers) => {
    try {
        const response = await instance.post('/salariedstaff', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        console.log(err);
        return err
    }
}
const SOPAdd = async (data, headers) => {
    try {
        const response = await instance.post('/sop', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err.response.data
    }
}

const SOPGet = async (data, headers) => {
    try {
        const response = await instance.post('/sopget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const SOPSoftDelete = async (data, headers) => {
    try {
        const response = await instance.patch('/sopdelete', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const IncidentReportAddPage = async (data, headers) => {
    try {
        const response = await instance.post('/incidentreportaddpage', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err.response.data
    }
}
const IncidentReportAdd = async (data, headers) => {
    try {
        const response = await instance.post('/incidentreport', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err.response.data
    }
}
const IncidentReportGet = async (data, headers) => {
    try {
        const response = await instance.post('/incidentreportget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const IncidentReportUpdate = async (data, headers) => {
    try {
        const response = await instance.patch('/incidentreport', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err.response.data
    }
}
const IncidentReportSoftDelete = async (data, headers) => {
    try {
        const response = await instance.patch('/incidentreportdelete', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const OccurrenceListPage = async (data, headers) => {
    try {
        const response = await instance.post('/occurrencelistpage', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const OccurrenceSoftDelete = async (data, headers) => {
    try {
        const response = await instance.patch('/occurrencedelete', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const OccurrenceAdd = async (data, headers) => {
    try {
        const response = await instance.post('/occurrence', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}
const OccurrenceUpdate = async (data, headers) => {
    try {
        const response = await instance.patch('/occurrence', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {

        //console.log(err);
        return err
    }
}

const DutyTypesGet = async (data, headers) => {
    try {
        const response = await instance.post('/dutytypesget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}
const FloaterAttendanceAdd = async (data, headers) => {
    try {
        const response = await instance.post('/floaterattendanceadd', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}
const FloaterAttendanceGet = async (data, headers) => {
    try {
        const response = await instance.post('/floaterattendanceget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}
const FloaterAttendanceUpdate = async (data, headers) => {
    try {
        const response = await instance.patch('/floaterattendance', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}
const FloaterCreditGet = async (data, headers) => {
    try {
        const response = await instance.post('/floatercredits', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}

const AcadamicsGet = async (data, headers) => {
    try {
        const response = await instance.post('/acadamicsget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}

const RemarksGet = async (data, headers) => {
    try {
        const response = await instance.post('remarksget', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}

const TimesheetRemarksAdd = async (data, headers) => {
    try {
        const response = await instance.post('timesheetremarksadd', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        return err.response.data
    }
}
const TimesheetRemarksUpdate = async (data, headers) => {
    try {
        const response = await instance.patch('timesheetremarks', data
            //    , {
            //     headers: {
            //         "Content-Type": "application/json",
            //         "access_token": headers.access_token,
            //     }
            // }
        );
        return response.data;
    } catch (err) {
        console.log("err", err)
        return err.response.data
    }
}



const Apiservice = {
    Login, Logout, SideMenubarPage,
    AddUserPreview, AddUser, AllUser, GetUserById, SoftDeleteUser, UpdateUser,
    AcadamicsGet,
    AddQuestion, AllQuestion, AllQuestionByExam, QuestionById, UpdateQuestion, SoftDeleteQuestion,
    AddSummary, GetQuizSummary, GetQuizSummaryById, GetQuizSummaryByUserExam, GetQuizSummaryByUser, QuizEdit,
    QuizUpdate, AllExam, ExamAdd,
    GetAllRoles, GetRoleById, AllRoles,
    DashBoard,
    Report, ConsolidatedReportPage,
    AllSites, AddSite, SiteProfile, SiteEditPage, UpdateSite, SoftDeleteSite,
    CheckInAttendance, CheckOutAttendance, GetAttendanceByEntryDate, AttendanceAssign, GetAttendance,
    AttendancePageByUser, AttendanceEditPage, UpdateAttendance, SoftDeleteAttendance, HardDeleteAttendance,
    TimeSheet,
    AddKET, KETAddPage, KETEditPage, KETUpdate,
    LeaveCategoriesGet,
    LeaveAdd, LeaveGet, LeaveApproveOrCancel, LeaveApplicationListPage,
    LeaveAllotmentAdd, LeaveAllotmentUpdate,
    Pwm,
    PayslipAdd, PayslipGet, SalariedStaff,
    SOPAdd, SOPGet, SOPSoftDelete,
    IncidentReportAddPage, IncidentReportAdd, IncidentReportGet, IncidentReportUpdate, IncidentReportSoftDelete,
    OccurrenceListPage, OccurrenceSoftDelete, OccurrenceAdd, OccurrenceUpdate,
    DutyTypesGet,
    FloaterAttendanceAdd, FloaterAttendanceGet, FloaterAttendanceUpdate, FloaterCreditGet,
    RemarksGet,
    TimesheetRemarksAdd, TimesheetRemarksUpdate,
}
export default Apiservice;